import cornerstone from "cornerstone-core";
import cornerstoneTools from "cornerstone-tools";

const BaseTool = cornerstoneTools.importInternal("base/BaseTool");

const { wwwcCursor } = cornerstoneTools.import("tools/cursors");

export class HFlip extends BaseTool {
  constructor(name = "HFlip") {
    super({
      name,
      //strategies: { basicLevelingStrategy },
      supportedInteractionTypes: ["Mouse"], //, 'Touch'],
      configuration: {
        orientation: 0,
      },
      svgCursor: wwwcCursor,
    });
  }

  mouseClickCallback(evt) {
    let vp = cornerstone.getViewport(evt.detail.element);
    vp.hflip = !vp.hflip;
    cornerstone.setViewport(evt.detail.element, vp);
  }

  //For programatically executing the functionality
  autoPerform(element) {
    let vp = cornerstone.getViewport(element);
    if (typeof vp !== "undefined") {
      if (typeof vp.hflip === "undefined") {
        vp.hflip = false; //Initialize the hflip property if not defined
      } else {
        vp.hflip = !vp.hflip; //Toggle the hflip property
      }
      cornerstone.setViewport(element, vp);
    }
  }
}
